import type { AvailableFacetForMagicFill } from "@/shared/types/magicFillTypes";

/**
 * As dimensões que classificam uma SKILL (AB#85634, AC27).
 *
 * === Por que um vocabulário próprio ===
 *
 * A primeira tentativa passou ao Magic Fill o vocabulário de facetas da
 * organização, que é o dos DOCUMENTOS da base de conhecimento — `type`,
 * `format`, `status`. O serviço descarta qualquer par fora do vocabulário
 * recebido, então a sugestão só podia vir de lá: a skill de testes acabou
 * marcada como `format:full` e `status:draft`, que não dizem nada sobre ela.
 *
 * O que classifica uma skill é outra coisa: a área que a usa, a categoria do
 * trabalho e a função que ela cumpre. É o que está aqui.
 *
 * === Por que `tool` não está nesta lista ===
 *
 * Ferramenta é aberta — `playwright`, `jira`, `figma`, o que o pacote citar — e
 * enumerar não terminaria nunca. Ela é pedida ao modelo em campo de texto
 * separado e vira `tool:<nome>` no cadastro, sem passar pelo filtro de
 * vocabulário que descartaria o que não estivesse previsto.
 *
 * Esta lista é o PONTO DE PARTIDA, não uma cerca: o campo de etiquetas aceita
 * qualquer par que quem registra queira declarar.
 */
const POR_DIMENSAO: Record<string, string[]> = {
  department: [
    "engineering",
    "product",
    "design",
    "marketing",
    "sales",
    "support",
    "operations",
    "finance",
    "people",
    "legal",
  ],
  category: [
    "devops",
    "testing",
    "security",
    "data",
    "discovery",
    "delivery",
    "documentation",
    "automation",
    "analytics",
    "governance",
  ],
  function: [
    "qa",
    "development",
    "review",
    "planning",
    "research",
    "writing",
    "analysis",
    "onboarding",
    "reporting",
    "support",
  ],
};

/** O vocabulário no formato que o Magic Fill espera. */
export const VOCABULARIO_DE_SKILL: AvailableFacetForMagicFill[] = Object.entries(POR_DIMENSAO)
  .flatMap(([name, valores]) => valores.map((value) => ({ name, value })))
  .map((facet) => ({ ...facet, label: undefined, parent: null }));

/** A dimensão das ferramentas, que não tem lista fechada. */
export const DIMENSAO_DE_FERRAMENTA = "tool";
